import { render, staticRenderFns } from "./RoleForm.vue?vue&type=template&id=59cd21b9"
import script from "./RoleForm.vue?vue&type=script&lang=js"
export * from "./RoleForm.vue?vue&type=script&lang=js"
import style0 from "./RoleForm.vue?vue&type=style&index=0&id=59cd21b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports